import { Tag } from '@factorialco/deprecated-design-system'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { useFilter } from 'modules/performance_process/components/review/show/Filters/context'
import { tagPropsForEmployeeScore } from 'modules/performance_process/lib/employeeScoreColor'

export interface ScoreScaleItem {
  text: string
  value: number
}

type Option = { label: string; component: React.ReactNode; value: number }

type ScoreFilterProps = {
  scoreScale: ScoreScaleItem[]
}

export const ScoreFilter = ({ scoreScale }: ScoreFilterProps) => {
  const { value, setValue } = useFilter('scores')

  const options: Option[] = [
    {
      label: i18n.t('performance_process.reviews.filters.no_data'),
      component: (
        <Tag leftItem="circle" showCircle type="grey" solid>
          {i18n.t('performance_process.reviews.filters.no_data')}
        </Tag>
      ),
      value: -1,
    },
    ...scoreScale.map((option) => ({
      label: option.text,
      component: (
        <Tag
          leftItem="circle"
          showCircle
          {...tagPropsForEmployeeScore(option.value, scoreScale.length)}
        >
          {option.text}
        </Tag>
      ),
      value: option.value,
    })),
  ]

  return (
    <Filter.MultipleChoice
      label={i18n.t('performance_process.reviews.target_datatable.final_score.title')}
      value={value}
      options={options}
      onValueChange={(newValue) => setValue(newValue ?? [])}
    />
  )
}
